const sub = [
  {
    threshold: 1,
    end: 25,
    content: 'one'
  },
  {
    threshold: 26,
    end: 50,
    content: 'two'
  },
  {
    threshold: 51,
    end: 71,
    content: 'three'
  },
  {
    threshold: 72,
    end: 95,
    content: 'four'
  },
  {
    threshold: 96,
    end: 127,
    content: 'five'
  },
  {
    threshold: 128,
    end: 154,
    content: 'six'
  },
  {
    threshold: 155,
    end: 177,
    content: 'seven'
  },
  {
    threshold: 178,
    end: 195,
    content: 'eight'
  },
  {
    threshold: 196,
    end: 217,
    content: 'nine'
  },
  {
    threshold: 218,
    end: 224,
    content: 'ten'
  },
  // {
  //   threshold: 440,
  //   end: 452,
  //   content: 'eleven'
  // }
]

export default sub